/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { AnalystTrendsTable } from "./rating-table/RatingTable";
import RatingChart from "./chart/RatingChart";
import { IAnalystTrendsDto } from "../../../../../../../services/tipRanks/types";
import styles from "./AnalystTrends.module.scss";

export const AnalystTrends = ({ data }: { data: IAnalystTrendsDto[] }) => {
    const chartData = data.map(({ period, ...rest }) => ({
        ...rest,
        name: period,
    }));

    return (
        <div className={styles.container}>
            <RatingChart data={chartData} />
            <AnalystTrendsTable data={data} />
        </div>
    );
};
